import type { ReactNode } from 'react';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';

type Props = {
  icon: ReactNode;
  value: ReactNode;
  size?: 'l' | 'm' | 's';
  css?: StyledCss;
};

const IconTextProperty = (props: Props) => {
  const size = props.size || 'm';

  return (
    <Flex a="center" g={gapSize[size]} css={props.css}>
      {props.icon}

      {typeof props.value === 'string' ? (
        <Typo style={{ fontSize: fontSize[size] }}>{props.value}</Typo>
      ) : (
        props.value
      )}
    </Flex>
  );
};

const gapSize = {
  s: 4,
  m: 4,
  l: 10,
};

const fontSize = {
  s: 10,
  m: 12,
  l: 16,
};

export default IconTextProperty;
